import type { LedgerSettlement } from "@/types/models";

const inr = (n: number) => "₹" + n.toLocaleString("en-IN", { maximumFractionDigits: 2 });

/**
 * Under a payment/receipt line in a party ledger: which bills (or invoices) it
 * settled, oldest first, and what is left held as credit. The server folds the
 * settlement rows into the payment, so the money that moved is ONE line.
 */
export default function SettlementLines({
  settled,
  held,
  docLabel,
}: {
  settled?: LedgerSettlement[] | null;
  held?: number | null;
  docLabel: "Bill" | "Invoice";
}) {
  const rows = settled ?? [];
  const heldAmt = held ?? 0;
  if (rows.length === 0 && heldAmt <= 0.005) return null;
  return (
    <ul className="mt-1 space-y-0.5 text-xs text-gray-500 dark:text-gray-400">
      {rows.map((s) => (
        <li key={s.doc_id}>
          Settled {docLabel.toLowerCase()} {s.doc_number || `#${s.doc_id}`}: {inr(s.amount)}
        </li>
      ))}
      {heldAmt > 0.005 && <li className="text-brand-600 dark:text-brand-400">{inr(heldAmt)} held as credit</li>}
    </ul>
  );
}
